import {
  createUnifiedTheme,
  createBaseThemeOptions,
  palettes,
} from '@backstage/theme';

// Placeholder brand colors — swap for the real SCGROUPS brand palette
// whenever it's available.
export const scgroupsTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: {
        main: '#1a2b4c',
      },
      secondary: {
        main: '#5ec8d8',
      },
      navigation: {
        ...palettes.light.navigation,
        background: '#1a2b4c',
        indicator: '#5ec8d8',
        color: '#d5dbe6',
        selectedColor: '#ffffff',
      },
    },
  }),
});
